// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../webpack-config-single-spa/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../webpack-config-single-spa/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Skeleton-HorizontalCard.module.scss  */
.Skeleton-HorizontalCard-module-Root_1Cl {
  display: grid;
  grid-template-areas: 'img text' 'img btn';
  grid-template-columns: 148px 1fr;
  grid-template-rows: auto auto;
  grid-gap: 0 12px; }

.Skeleton-HorizontalCard-module-Img_E1K {
  grid-area: img; }

.Skeleton-HorizontalCard-module-Wrapper_1CA {
  display: flex;
  flex-flow: column nowrap;
  grid-area: text;
  gap: 12px; }

.Skeleton-HorizontalCard-module-Btn_3EN {
  align-self: end;
  grid-area: btn; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Skeleton/HorizontalCard/Skeleton-HorizontalCard.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,aAAa;EACb,yCAAyC;EACzC,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,SAAS,EAAE;;AAEb;EACE,eAAe;EACf,cAAc,EAAE","sourcesContent":["/*  imported from Skeleton-HorizontalCard.module.scss  */\n.Skeleton-HorizontalCard-module-Root_1Cl {\n  display: grid;\n  grid-template-areas: 'img text' 'img btn';\n  grid-template-columns: 148px 1fr;\n  grid-template-rows: auto auto;\n  grid-gap: 0 12px; }\n\n.Skeleton-HorizontalCard-module-Img_E1K {\n  grid-area: img; }\n\n.Skeleton-HorizontalCard-module-Wrapper_1CA {\n  display: flex;\n  flex-flow: column nowrap;\n  grid-area: text;\n  gap: 12px; }\n\n.Skeleton-HorizontalCard-module-Btn_3EN {\n  align-self: end;\n  grid-area: btn; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
